import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ITextboxProps, TextboxControl } from "./TextboxControl";

interface SingleSelectTextBoxControlProps extends ITextboxProps {
    fontWeight?: string | number;
    isSelected: boolean;
    onRemove: () => void;
    selectedModeStyles?: React.CSSProperties;
    displayText?: string;
    alternateEditComponent?: JSX.Element;
    disableRemoveButton?: boolean;
}

class SingleSelectTextBoxControl extends BaseReactComponent<SingleSelectTextBoxControlProps> {
    public render(): JSX.Element {
        if (this.props.isSelected)
            return (
                <div
                    className="form-control input"
                    style={{
                        height: "37px",
                        display: "flex",
                        alignItems: "center",
                        border: "0",
                        fontWeight: this.props.fontWeight ?? "bold",
                        paddingLeft: "0",
                        ...this.props.selectedModeStyles
                    }}
                >
                    <span>{this.props.displayText || this.props.value || ""}</span>
                    {!this.props.disableRemoveButton && (
                        <span
                            className="pointer"
                            style={{ color: "red", marginLeft: "10px", cursor: "pointer" }}
                            onClick={() => this.props.onRemove()}
                        >
                            X
                        </span>
                    )}
                </div>
            );

        return this.props.alternateEditComponent || <TextboxControl {...this.props} />;
    }
}

export { SingleSelectTextBoxControl };
